'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.month;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/month.js
// module id = 713
// module chunks = 0